import {
  AlertTriangle,
  CheckCircle2,
  FileSignature,
  ShieldCheck,
  Stamp,
  UserCheck,
} from "lucide-react";

import jsPDF from "jspdf";
import "jspdf-autotable";

const handleDownloadPDF = (analysisResult) => {
  try {
    const data = analysisResult?.openAIResponse || analysisResult?.analysisData || {};
    const doc = new jsPDF("p", "pt", "a4");
    let yPos = 40;

    // Title
    doc.setFontSize(16);
    doc.text("Rental Agreement Analysis Report", 40, yPos);
    yPos += 40;

    // Document Identification
    doc.setFontSize(14);
    doc.text("Document Identification", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Document Type: ${data.documentDetails?.documentType || data.agreement?.type || 'N/A'}`, 40, yPos);
    doc.text(`Execution Date: ${data.documentDetails?.executionDate || data.agreement?.executionDate || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Place of Execution: ${data.documentDetails?.placeOfExecution || data.agreement?.place || 'N/A'}`, 40, yPos);
    doc.text(`Jurisdiction: ${data.documentDetails?.jurisdiction || data.agreement?.jurisdiction || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Stamp Duty Applied: ${data.documentDetails?.stampDutyApplied || data.agreement?.stampDuty || 'N/A'}`, 40, yPos);
    doc.text(`Registration Status: ${data.documentDetails?.registrationStatus || data.agreement?.registrationStatus || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Notarized: ${data.documentDetails?.notarized || data.agreement?.notarized || 'N/A'}`, 40, yPos);
    yPos += 30;

    // Party Details
    doc.setFontSize(14);
    doc.text("Party Details Verification", 40, yPos);
    yPos += 20;
    doc.setFontSize(12);
    doc.text("Party A (Tenant)", 40, yPos);
    doc.text("Party B (Landlord)", 300, yPos);
    yPos += 15;
    doc.setFontSize(10);
    doc.text(`Name: ${data.partyDetails?.partyA?.name || 'N/A'}`, 40, yPos);
    doc.text(`Name: ${data.partyDetails?.partyB?.name || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`PAN: ${data.partyDetails?.partyA?.pan || 'N/A'}`, 40, yPos);
    doc.text(`PAN: ${data.partyDetails?.partyB?.pan || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Role: ${data.partyDetails?.partyA?.role || 'N/A'}`, 40, yPos);
    doc.text(`Role: ${data.partyDetails?.partyB?.role || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Contact: ${data.partyDetails?.partyA?.contact || 'N/A'}`, 40, yPos);
    doc.text(`Contact: ${data.partyDetails?.partyB?.contact || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Key Clauses
    doc.setFontSize(14);
    doc.text("Key Clauses Extracted", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Agreement Purpose: ${data.keyClauses?.agreementPurpose || 'N/A'}`, 40, yPos);
    doc.text(`Monthly Rent: Rs ${data.keyClauses?.monthlyRent || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Exit/Termination Clause: ${data.keyClauses?.exitTerminationClause || 'N/A'}`, 40, yPos);
    doc.text(`Security Deposit: Rs ${data.keyClauses?.securityDeposit || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Effective Date & Duration: ${data.keyClauses?.effectiveDateDuration || 'N/A'}`, 40, yPos);
    doc.text(`Legal Remedies: ${data.keyClauses?.legalRemedies || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Renewal Terms: ${data.keyClauses?.renewalTerms || 'N/A'}`, 40, yPos);
    doc.text(`Stamp Act Compliance: ${data.keyClauses?.stampActCompliance || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Rental Agreement Specific
    doc.setFontSize(14);
    doc.text("Rental Agreement Specific Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Monthly Rent: Rs ${data.rentalSpecific?.monthlyRent || 'N/A'}`, 40, yPos);
    doc.text(`Premises Use: ${data.rentalSpecific?.premisesUse || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Security Deposit: ${data.rentalSpecific?.securityDeposit || 'N/A'}`, 40, yPos);
    doc.text(`Tenant Name Matches: ${data.rentalSpecific?.tenantNameMatches || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Landlord Ownership Evidence: ${data.rentalSpecific?.landlordOwnershipEvidence || 'N/A'}`, 40, yPos);
    doc.text(`Rent Receipt Format: ${data.rentalSpecific?.rentReceiptFormat || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Risk & Red Flags
    doc.setFontSize(14);
    doc.text("Risk & Red Flag Analysis", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Document Undated/Backdated: ${data.riskRedFlags?.documentUndatedBackdated || 'N/A'}`, 40, yPos);
    doc.text(`Address Mismatch: ${data.riskRedFlags?.addressMismatch || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Inadequate Stamp Duty: ${data.riskRedFlags?.inadequateStampDuty || 'N/A'}`, 40, yPos);
    doc.text(`Missing Ownership Proof: ${data.riskRedFlags?.missingOwnershipProof || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Missing Key Signatures: ${data.riskRedFlags?.missingKeySignatures || 'N/A'}`, 40, yPos);
    doc.text(`Unclear Terms/Conditions: ${data.riskRedFlags?.unclearTermsConditions || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Document Verdict
    doc.setFontSize(14);
    doc.text("Document Analyst Verdict", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    doc.text(`Legally Enforceable: ${data.documentVerdict?.legallyEnforceable || 'N/A'}`, 40, yPos);
    doc.text(`Supports KYC Claims: ${data.documentVerdict?.supportsKycClaims || 'N/A'}`, 300, yPos);
    yPos += 15;
    doc.text(`Parties Authenticated: ${data.documentVerdict?.partiesAuthenticated || 'N/A'}`, 40, yPos);
    doc.text(`Fit for Lending: ${data.documentVerdict?.fitForLending || 'N/A'}`, 300, yPos);
    yPos += 30;

    // Final Comments
    doc.setFontSize(14);
    doc.text("Final Comments", 40, yPos);
    yPos += 20;
    doc.setFontSize(10);
    const comments = data.finalComments || [
      "Rental agreement analysis completed based on available documentation.",
      "Party verification and clause extraction have been assessed.",
      "Document authenticity and legal compliance reviewed."
    ];
    comments.forEach(comment => {
      doc.text(`• ${comment}`, 40, yPos);
      yPos += 15;
    });

    doc.save("rental-agreement-analysis-report.pdf");
  } catch (error) {
    console.error('PDF generation error:', error);
    alert(`Error generating PDF: ${error.message}`);
  }
};

const Section = ({ icon: Icon, title, children }) => (
  <div className="border border-gray-700 rounded-lg p-5 mb-6">
    <div className="flex items-center mb-4 text-white">
      <Icon className="w-5 h-5 text-yellow-400 mr-2" />
      <h2 className="text-lg font-semibold">{title}</h2>
    </div>
    {children}
  </div>
);

const FieldRow = ({ label, value }) => (
  <div className="flex flex-col sm:flex-row sm:justify-between text-sm text-gray-300 mb-2">
    <span className="font-medium text-white">{label}</span>
    <span>{value}</span>
  </div>
);

const RentalAgreementReport = ({ analysisResult }) => {
  const data =
    analysisResult?.openAIResponse || analysisResult?.analysisData || {};

  const getValue = (path, defaultValue = "N/A") => {
    return (
      path?.split(".").reduce((obj, key) => obj?.[key], data) || defaultValue
    );
  };
  return (
    <div className="bg-[#131313] text-white p-4 sm:p-6 text-sm space-y-6 min-h-screen max-w-7xl mx-auto">
      {/* Header */}
      <div className="flex flex-col sm:flex-row sm:justify-between sm:items-start gap-4">
        <div className="w-full sm:max-w-sm">
          <label className="block mb-1 text-sm">Select Analyzer Type</label>
          <select className="w-full bg-[#1f1f1f] border border-[#333] rounded-md px-4 py-2 text-white">
            <option>Universal Agreement & Legal Letter Analyser</option>
          </select>
        </div>
        <div className="flex flex-col sm:flex-row gap-2 w-full sm:w-auto">
          
          <button
            onClick={() => handleDownloadPDF(analysisResult)}
            className="bg-[#FFCA20] hover:bg-[#e6b91a] text-black px-4 py-2 rounded-md font-semibold text-sm"
          >
            Download Report
          </button>
        </div>
      </div>

      {/* Document Identification */}
      <div className="bg-[#1f1f1f] rounded-lg p-4 space-y-2 border border-[#2a2a2a]">
        <h2 className="text-yellow-400 text-lg font-semibold">
          📄 Document Identification
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Document Type</strong>
            <span className="text-white">
              {getValue("documentDetails.documentType") ||
                getValue("agreement.type")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Date of Execution</strong>
            <span className="text-white">
              {getValue("documentDetails.executionDate") ||
                getValue("agreement.executionDate")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Place of Execution</strong>
            <span className="text-white">
              {getValue("documentDetails.placeOfExecution") ||
                getValue("agreement.place")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Jurisdiction</strong>
            <span className="text-white">
              {getValue("documentDetails.jurisdiction") ||
                getValue("agreement.jurisdiction")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Stamp Duty Applied</strong>
            <span className="text-white">
              {getValue("documentDetails.stampDutyApplied") ||
                getValue("agreement.stampDuty")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Registration Status</strong>
            <span className="text-white">
              {getValue("documentDetails.registrationStatus") ||
                getValue("agreement.registrationStatus")}
            </span>
          </div>
          <div className="flex flex-col">
            <strong className="text-[#AAAAAA]">Notarized</strong>
            <span className="text-white">
              {getValue("documentDetails.notarized") ||
                getValue("agreement.notarized")}
            </span>
          </div>
          <div className="flex flex-col col-span-1 sm:col-span-2 lg:col-span-3">
            <strong className="text-[#AAAAAA]">Parties Involved</strong>
            <span className="text-white">
              {getValue("documentDetails.partiesInvolved") ||
                getValue("agreement.parties")}
            </span>
          </div>
        </div>
      </div>

      {/* Party Details Verification */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <UserCheck size={18} /> Party Details Verification
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <h3 className="text-yellow-400 font-semibold mb-2">
              Party A (Tenant)
            </h3>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Name</strong>
              <span className="text-white">
                {data.partyDetails?.partyA?.name || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">PAN</strong>
              <span className="text-white">
                {data.partyDetails?.partyA?.pan || "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <strong className="text-[#AAAAAA]">Address</strong>
              <span className="text-white">
                {data.partyDetails?.partyA?.address || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Role</strong>
              <span className="text-white">
                {data.partyDetails?.partyA?.role || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Contact</strong>
              <span className="text-white">
                {data.partyDetails?.partyA?.contact || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <h3 className="text-yellow-400 font-semibold mb-2">
              Party B (Landlord)
            </h3>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Name</strong>
              <span className="text-white">
                {data.partyDetails?.partyB?.name || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">PAN</strong>
              <span className="text-white">
                {data.partyDetails?.partyB?.pan || "N/A"}
              </span>
            </div>
            <div className="flex flex-col">
              <strong className="text-[#AAAAAA]">Address</strong>
              <span className="text-white">
                {data.partyDetails?.partyB?.address || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Role</strong>
              <span className="text-white">
                {data.partyDetails?.partyB?.role || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Contact</strong>
              <span className="text-white">
                {data.partyDetails?.partyB?.contact || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Key Clauses */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <ShieldCheck size={18} /> Key Clauses Extracted
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Agreement Purpose</strong>
              <span className="text-white">
                {data.keyClauses?.agreementPurpose || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Exit/Termination Clause
              </strong>
              <span className="text-white">
                {data.keyClauses?.exitTerminationClause || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Effective Date & Duration
              </strong>
              <span className="text-white">
                {data.keyClauses?.effectiveDateDuration || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Renewal Terms</strong>
              <span className="text-white">
                {data.keyClauses?.renewalTerms || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Monthly Rent</strong>
              <span className="text-white">
                ₹{data.keyClauses?.monthlyRent?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Legal Remedies</strong>
              <span className="text-white">
                {data.keyClauses?.legalRemedies || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Security Deposit</strong>
              <span className="text-white">
                ₹{data.keyClauses?.securityDeposit?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Stamp Act Compliance</strong>
              <span className="text-white">
                {data.keyClauses?.stampActCompliance || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Validation Checklist */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <FileSignature size={18} /> Validation Checklist
        </div>
        <div className="grid grid-cols-2 gap-4 mt-2 mb-3">
          <h4 className="text-[#AAAAAA] font-semibold">Parameter</h4>
          <h4 className="text-[#AAAAAA] font-semibold">Verification</h4>
        </div>
        <div className="space-y-3 mt-2">
          {(
            data.validationChecklist || [
              { parameter: "Signed by All Parties", verification: "Yes" },
              {
                parameter: "Signature Consistency with KYC",
                verification: "Yes",
              },
              {
                parameter: "ID Proof Mentioned (PAN/Aadhaar)",
                verification: "Yes",
              },
              {
                parameter: "Address Matches KYC/Application",
                verification: "Yes",
              },
              { parameter: "Legal & Jurisdiction Clause", verification: "Yes" },
              { parameter: "Rental Rate Reasonable", verification: "Yes" },
              { parameter: "Supports Declared Income", verification: "No" },
              { parameter: "Stamped/Notarized", verification: "Yes" },
            ]
          ).map((item) => (
            <div key={item.parameter} className="grid grid-cols-2 gap-4">
              <strong className="text-[#AAAAAA]">{item.parameter}</strong>
              <span
                className={
                  item.verification === "Yes"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {item.verification === "Yes" ? "Verified" : "Not Verified"}
              </span>
            </div>
          ))}
        </div>
      </div>

      {/* Agreement Specific */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <Stamp size={18} /> Rental Agreement Specific Analysis
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Monthly Rent</strong>
              <span className="text-white">
                ₹{data.rentalSpecific?.monthlyRent?.toLocaleString("en-IN") || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Premises Use</strong>
              <span className="text-white">
                {data.rentalSpecific?.premisesUse || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Security Deposit</strong>
              <span className="text-white">
                {data.rentalSpecific?.securityDeposit || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Tenant Name Matches Applicant
              </strong>
              <span className="text-white">
                {data.rentalSpecific?.tenantNameMatches || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Landlord Ownership Evidence
              </strong>
              <span className="text-white">
                {data.rentalSpecific?.landlordOwnershipEvidence || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Rent Receipt Format</strong>
              <span className="text-white">
                {data.rentalSpecific?.rentReceiptFormat || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Risk & Red Flags */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a]">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <AlertTriangle size={18} /> Risk & Red Flag Analysis
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-2">
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Document Undated/Backdated
              </strong>
              <span
                className={
                  data.riskRedFlags?.documentUndatedBackdated === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.documentUndatedBackdated || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Address Mismatch</strong>
              <span
                className={
                  data.riskRedFlags?.addressMismatch === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.addressMismatch || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Inadequate Stamp Duty</strong>
              <span
                className={
                  data.riskRedFlags?.inadequateStampDuty === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.inadequateStampDuty || "N/A"}
              </span>
            </div>
          </div>
          <div className="space-y-3">
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Missing Ownership Proof
              </strong>
              <span
                className={
                  data.riskRedFlags?.missingOwnershipProof === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.missingOwnershipProof || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">Missing Key Signatures</strong>
              <span
                className={
                  data.riskRedFlags?.missingKeySignatures === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.missingKeySignatures || "N/A"}
              </span>
            </div>
            <div className="flex justify-between">
              <strong className="text-[#AAAAAA]">
                Unclear Terms/Conditions
              </strong>
              <span
                className={
                  data.riskRedFlags?.unclearTermsConditions === "No"
                    ? "text-green-400"
                    : "text-red-400"
                }
              >
                {data.riskRedFlags?.unclearTermsConditions || "N/A"}
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Verdict */}
      <div className="bg-[#1f1f1f] p-4 rounded-lg border border-[#2a2a2a] text-center">
        <div className="flex items-center gap-2 text-yellow-400 font-semibold text-lg">
          <CheckCircle2 size={18} /> Document Analyst Verdict
        </div>
        <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4">
          <div>
            <strong className="text-[#AAAAAA]">Legally Enforceable</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.documentVerdict?.legallyEnforceable || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Supports KYC Claims</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.documentVerdict?.supportsKycClaims || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Parties Authenticated</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.documentVerdict?.partiesAuthenticated || "N/A"}
            </span>
          </div>
          <div>
            <strong className="text-[#AAAAAA]">Fit for Lending</strong>
            <br />
            <span className="text-green-400 text-lg">
              {data.documentVerdict?.fitForLending || "N/A"}
            </span>
          </div>
        </div>
      </div>

      {/* Final Comments */}
      <div className="bg-green-900/20 border border-green-500 rounded-lg p-5 mt-6">
        <h2 className="text-green-400 font-semibold mb-3">Final Comments</h2>
        <ul className="list-disc list-inside text-sm text-gray-300 space-y-1">
          {data.finalComments?.map((comment, index) => (
            <li key={index}>{comment}</li>
          )) || [
            <li key="default1">
              Rental agreement analysis completed based on available
              documentation.
            </li>,
            <li key="default2">
              Party verification and clause extraction have been assessed.
            </li>,
            <li key="default3">
              Document authenticity and legal compliance reviewed.
            </li>,
          ]}
        </ul>
      </div>
    </div>
  );
};

export default RentalAgreementReport;
